export const rewardColumns = [
  ['actions', 'Thao tác'],
  ['user', 'Người chơi'],
  ['ticketId', 'Mã vé'],
  ['game', 'Trò chơi / Kỳ quay'],
  ['details', 'Chi tiết vé'],
  ['images', 'Hình ảnh'],
  ['grossValue', 'Tiền trúng'],
  ['tax', 'Thuế'],
  ['fee', 'Phí'],
  ['netValue', 'Thực nhận'],
  ['status', 'Trạng thái'],
  ['createdAt', 'Ngày trúng']
];

export const defaultRewardColumns = [
  'actions', 'user', 'ticketId', 'game', 'grossValue', 'netValue', 'status', 'createdAt'
];

export const sortableRewardColumns = ['user', 'ticketId', 'grossValue', 'netValue', 'status', 'createdAt'];

export function loadRewardColumns(scope) {
  try {
    const saved = JSON.parse(localStorage.getItem(`reward-columns:${scope}`));
    if (Array.isArray(saved)) {
      return ['actions', ...rewardColumns.map(([id]) => id).filter(id => id !== 'actions' && saved.includes(id))];
    }
  } catch (_) {
    // Storage may be unavailable.
  }
  return [...defaultRewardColumns];
}
